App.OshaIncidentsLogTable = class extends App.DataTable {
  constructor(table) {
    const dataSourceUrl = `/osha/incidents/data_table?year=${table.data("year")}`;

    const columns = [
      {
        data: 'case_number',
        className: 'all',
        width: '48px'
      },

      {
        data: 'date_of_incident',
        className: 'all',
        width: '80px'
      },

      {
        data: 'source',
        className: 'all',
        width: '48px'
      },

      {
        data: 'employee_name',
        className: 'all',
      },

      {
        data: 'location',
        className: 'all',
      },

      {
        data: 'days_away_from_work',
        className: 'all',
        width: '48px'
      },

      {
        data: 'days_on_transfer_or_restriction',
        className: 'all',
        width: '48px'
      },

      {
        data: 'status',
        className: 'all',
      },

      {
        sortable: false,
        render: function(data, type, full, meta) {
          return '<a href="' + full.edit_link + '" class="btn btn-xs btn-muted-blue">Edit</a>';
        },
        width: '48px'
      },

      {
        data: 'year',
        className: 'all',
        visible: false,
        render: function(data, type, full, meta) { return ""; }
      }
    ]

    const noData = '<span class="fa fa-info-sign"></span><p>No incidents logged.</p>';

    const searchFilterHtml = {
      'filter-case_number': '<input type="text" class="form-control input-sm filter-text" ' +
                              'placeholder="#" ' +
                              'name="filter-case_number-input" ' +
                              'style="min-width: auto;" />',

      'filter-date_of_incident': '<input type="text" class="form-control input-sm filter-text" ' +
                                   'placeholder="mm/dd/yyyy" ' +
                                   'name="filter-date_of_incident-input" ' +
                                   'id="filter-date_of_incident-input" ' +
                                   'style="min-width: 92px;"  />',

      'filter-employee_name': '<input type="text" class="form-control input-sm filter-text" ' +
                                'placeholder="Search" ' +
                                'name="filter-employee_name-input" />',

      'filter-location': ((locations) => {
        return [
          '<select class="form-control input-sm">',
            '<option selected="selected" value="">Any</option>',

            ...(locations.map((l) => {
              return `<option value="${l.value}">${l.label}</option>`;
            })),
          '</select>'
        ].join("");
      })($("#filter-location").data("locations")),

      'filter-source': [
        '<select class="form-control input-sm">',
          '<option selected="selected" value="">Any</option>',
          '<option value="manual">Manual</option>',
          '<option value="imported_from_claim">Imported</option>',
        '</select>'
      ].join(""),

      'filter-status': [
        '<select class="form-control input-sm">',
          '<option selected="selected" value="">Any</option>',
          '<option value="incomplete">Incomplete</option>',
          '<option value="new">New</option>',
          '<option value="non_recordable">Non-recordable</option>',
          '<option value="recordable">Recordable</option>',
        '</select>'
      ].join("")
    };

    super({
      table:            table,
      dataSourceUrl:    dataSourceUrl,
      columns:          columns,
      searchFilterHtml: searchFilterHtml,
      initialOrder:     [[1, "desc"]],
      noData:           noData
    })
  }
}

$(document).on('turbo:load', function() {
  if($(".incidents.index").length == 0) { return; }

  let table = new App.OshaIncidentsLogTable($("table#osha_incidents"));
  table.render();
});
